

import { useReducer, } from "react"
import { Box, Tooltip } from "@mui/material"
import DefaultModal from "../../../components/modal/DefaultModal/DefaultModal"
import lockedReducer from "../../../lib/reducer"
import { emitSnackbar } from "../../../lib/snackbar-emitter"
import api, { getEnterpriseId } from "../../../lib/api"
import { loader } from "../../../lib/loader"
import { Input } from "../../../components/ui/input"
import { RoundedButton } from "../../../components/ui/roundButton"
import { formatPhoneNumber } from "../../../services/scout"

const captcha = 'reenviar'
const ResendEmail = ({ account, handleClose, handleSuccess }) => {

    const [state, setState] = useReducer(lockedReducer, {
        captcha: ''
    })

    const submit = async () => {
        loader.on()
        const enterpriseId = getEnterpriseId()
        const res = await api.get(`/enterprises/${enterpriseId}/scout_accounts/${account.id}/renotify/`)
        if (res.status === 200){
            emitSnackbar({message: 'E-mail reenviado com sucesso!', severity:'success'})
            handleClose()
            handleSuccess()
        } else {
            emitSnackbar({message: 'Falha para reenviar o e-mail.', severity:'error'})
        }
        loader.off()
    }


    return (
        <DefaultModal
            title={
                'Reenviar convite'
            }
            handleClose={handleClose}
            maxWidth="xs"
            action={
                <Box width='100%' display='flex' gap='1rem' sx={{ justifyContent: 'space-between', marginTop: '1rem' }}>
                    <Box sx={{ width: '100%' }}>
                        <RoundedButton onClick={handleClose} rounded='outlined' sx={{ width: '100%' }}>
                            Cancelar
                        </RoundedButton>
                    </Box>
                    <Box sx={{ width: '100%' }}>
                        <Tooltip title={'Digite a mensagem correta.'}>
                            <span sx={{ width: '100%' }}>
                                <RoundedButton sx={{ width: '100%' }} disabled={state.captcha !== captcha} onClick={submit}>
                                    Salvar
                                </RoundedButton>
                            </span>
                        </Tooltip>
                    </Box>
                </Box>
            }
        >
            <Box display='flex' gap='1rem' flexDirection='column'>
                <Box  className="bg-gray-100 rounded-xl p-4 text-center" sx={{background: '#ebf4f6'}}>
                    <Box className="font-bold text-sm text-gray-900">{account.name}</Box>
                    <Box className="text-sm text-gray-400">{formatPhoneNumber(account.phone_number)}</Box>
                </Box>
                <Box className="text-sm text-gray-700">
                    Se deseja reenviar o convite por e-mail, digite <strong>{captcha}</strong> no campo abaixo:
                </Box>
                <Input 
                    placeholder="Preencha e confirme"
                    value={state.captcha}
                    onChange={({target}) => setState({captcha: target.value})}
                    className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm text-gray-700 placeholder:text-gray-300 outline-none focus:border-gray-300 bg-white"
                />
            </Box>
        </DefaultModal>
    )
}

export default ResendEmail